import { Component, OnInit } from '@angular/core';
import {KontableComponent} from '../../../modules/UIKit/components/kontable/kontable.component';
import {Permission} from '../../../models/permission.model';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {PermsService} from '../../../services/utils/perms.service';
import {LoyaltySelfscanserviceService} from '../../../services/loyalty/loyalty-selfscanservice.service';
import {Observable} from 'rxjs/Observable';
import {SelfScanConf} from '../../../models/loyalty-selfScan.model';
import {SelfScanService} from '../../../models/loyalty-selfScan-service.model';

@Component({
  selector: 'app-loyalty-self-scan-service',
  templateUrl: './loyalty-self-scan-service.component.html',
  styleUrls: ['./loyalty-self-scan-service.component.css']
})
export class LoyaltySelfScanServiceComponent implements OnInit {

  newDataAvailable = false;
  serverPagination = KontableComponent.ServerPagination;
  listStates: Array<{value: string, label: string}>;
  listStatesBl: Array<{value: string, label: string}>;
  selectFilter = KontableComponent.SelectFilter;
  customFilter = KontableComponent.CustomFilter;

  // Mostra tasti di edit, delete e recover
  selfScanningPermissions: Permission;

  render = {
    datatable: false
  };

  constructor(
    public selfscanService: LoyaltySelfscanserviceService,
    private router: Router,
    private translate: TranslateService,
    private srvPermission: PermsService
  ) { }

  ngOnInit() {

    const TRANSLATIONS = this.translate.get([
      'common.status_notDeleted',
      'common.status_onlyDeleted',
      'common.status_onlySuspended',
      'loyalty.blacklist'
    ]);

    const PERMISSIONS = this.srvPermission.getPermission({ms_base: 'koncentro-loyalty', operation: 'self_scanning'});


    Observable.zip(
      TRANSLATIONS,
      PERMISSIONS

    ).subscribe(([t, resPermissions]) => {

      this.selfScanningPermissions = resPermissions;

      this.listStates = [];
      this.listStates.push({ label: '', value: null });
      this.listStates.push({ label: t['common.status_notDeleted'], value: '0' });
      this.listStates.push({ label: t['common.status_onlyDeleted'], value: '1' });

      this.listStatesBl = [];
      this.listStatesBl.push({ label: '', value: null });
      this.listStatesBl.push({ label: t['common.status_notDeleted'], value: '0' });
      this.listStatesBl.push({ label: t['loyalty.blacklist'], value: '1' });

      this.render.datatable = true;

    });



  }

  edit(selfscanservice: SelfScanService) {
    this.router.navigate(['/loyalty/selfscanservice/form/' + selfscanservice.id]);
  }

  onOpen(selfscanservice: SelfScanService) {
    this.router.navigate(['/loyalty/selfscanservicedetail/' + selfscanservice.id]);
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-self-scan-service/loyalty-self-scan-service.component.ts